<template>
    <ModalHost
        v-for="entry in modalStack"
        :key="entry.id"
        :entry="entry"
    />
</template>

<script lang="ts" setup>
import useModal from '@/composables/modal'
import ModalHost from './ModalHost.vue'

const { modalStack } = useModal()
</script>
